import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { Formik } from 'formik';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Container,
  Grid,
  FormHelperText,
  TextField
} from '@material-ui/core';
import { useToast } from 'src/contexts/toast';
import { getMakeByID, updateMakeByID } from '../../redux/vehicles-make/action';

const EditMake = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { showToast } = useToast();
  const location = useLocation();
  const [makeInfo, setMakeInfo] = useState();
  const makeID = location.state;

  useEffect(() => {
    const fetchData = async () => {
      const data = await dispatch(getMakeByID(location.state));
      setMakeInfo(data[0]);
    };
    fetchData();
  }, [makeID]);

  const goBack = () => {
    navigate('/app/makes');
  };

  return (
    <Container maxWidth={false}>
      <Box paddingTop={3}>
        <Card>
          <CardHeader title="Edit Make" />
        </Card>
      </Box>
      <Box paddingTop={3}>
        <Card>
          <CardContent>
            <Grid container spacing={2} justifyContent="flex-start">
              <Grid item xs={12} sm={6}>
                <Formik
                  enableReinitialize
                  initialValues={{
                    make: makeInfo ? makeInfo.make : ''
                  }}
                  validationSchema={Yup.object().shape({
                    make: Yup.string()
                      .max(255)
                      .required('make is required')
                  })}
                  onSubmit={async (values) => {
                    try {
                      await dispatch(updateMakeByID(values, makeID));
                      showToast("Make is updated successfully!");
                      navigate('/app/makes', { replace: true });
                    } catch (error) {
                      showToast(error.message, "warning");
                    }
                  }}
                >
                  {({
                    errors,
                    handleBlur,
                    handleChange,
                    handleSubmit,
                    isSubmitting,
                    touched,
                    values
                  }) => (
                    <form onSubmit={handleSubmit}>
                      <TextField
                        error={Boolean(
                          touched.make && errors.make
                        )}
                        fullWidth
                        helperText={touched.make && errors.make}
                        label="Enter Make"
                        margin="normal"
                        name="make"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.make}
                        variant="outlined"
                      />
                      {Boolean(touched.policy && errors.policy) && (
                        <FormHelperText error>{errors.policy}</FormHelperText>
                      )}
                      <Box paddingY={3}>
                        <Grid container spacing={3}>
                          <Grid item xs={12} sm={6}>
                            <Button
                              color="primary"
                              disabled={isSubmitting}
                              size="large"
                              fullWidth
                              type="submit"
                              variant="contained"
                            >
                              UPDATE
                            </Button>
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <Button
                              color="primary"
                              disabled={isSubmitting}
                              size="large"
                              fullWidth
                              onClick={goBack}
                              variant="contained"
                            >
                              GO BACK
                            </Button>
                          </Grid>
                        </Grid>
                      </Box>
                    </form>
                  )}
                </Formik>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
};

export default EditMake;
